import React from "react";
import PropTypes from "prop-types";

export const SignInAvatar = ({ color = "#333" }) => {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    //   <g clipPath="url(#clip0_935_35768)">
    //     <path
    //       d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.35 18.5C8.66 17.56 10.26 17 12 17C13.74 17 15.34 17.56 16.65 18.5C15.34 19.44 13.74 20 12 20C10.26 20 8.66 19.44 7.35 18.5ZM18.14 17.12C16.45 15.8 14.32 15 12 15C9.68 15 7.55 15.8 5.86 17.12C4.7 15.73 4 13.95 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 13.95 19.3 15.73 18.14 17.12Z"
    //       fill="black"
    //     />
    //     <path
    //       d="M12 6C10.07 6 8.5 7.57 8.5 9.5C8.5 11.43 10.07 13 12 13C13.93 13 15.5 11.43 15.5 9.5C15.5 7.57 13.93 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z"
    //       fill="black"
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_935_35768">
    //       <rect width="24" height="24" fill="white" />
    //     </clipPath>
    //   </defs>
    // </svg>
    <i className="sign-in-avatar" />
  );
};

SignInAvatar.propTypes = {
  color: PropTypes.string,
};
